import MasterShopSpecifyPage from './MasterShopSpecifyPage';

export default MasterShopSpecifyPage;
